export default __webpack_public_path__ + "static/light-forbes-logo-59238db530678e9b92334d008eed201d.svg";